import { Component } from "./Component";
import { vp } from "../managers/vp";
import { api } from "../libs/apis/api";
import { MediaItemComponent } from "./MediaItemComponent";
import { ListSlider } from "./sliders/ListSlider";
import { GridList } from "./sliders/GridList";
import { ProjectDomUtils } from "../libs/utils/ProjectDomUtils";
import { StringUtils } from "socios-tools/utils/StringUtils";
import { DomUtils } from "socios-tools/utils/DomUtils";
export class ChunkLoader extends Component {
    constructor() {
        super(...arguments);
        this._currentChunk = 1;
        this._loadQueue = [];
        this._loader = null;
        this._triggerOffset = 250;
        this.onScroll = () => {
            this.checkForNextLoad();
        };
    }
    init() {
        if (vp.config.chunkData) {
            this.checkForNextLoad();
            window.addEventListener('scroll', this.onScroll);
        }
    }
    checkForNextLoad() {
        const scrollBottom = ProjectDomUtils.getScrollElement().scrollTop + window.innerHeight;
        if (!this._loader && scrollBottom > ProjectDomUtils.getScrollElement().scrollHeight - this._triggerOffset) {
            if (!this.addNextChunkToQueue()) {
                window.removeEventListener('scroll', this.onScroll);
            }
        }
    }
    addNextChunkToQueue() {
        const nextChunk = this._currentChunk + 1;
        if (nextChunk <= vp.config.chunkData.count) {
            this._currentChunk = nextChunk;
            const nextChunkUrl = StringUtils.replaceVars(vp.config.chunkData.url, { 'num': nextChunk });
            this._loadQueue.push(nextChunkUrl);
            this.loadNext();
            return true;
        }
        return false;
    }
    loadNext() {
        if (!this._loader && this._loadQueue.length > 0) {
            const url = this._loadQueue.shift();
            this.showLoader(true);
            this._loader = api.get(url).then((result) => {
                this.showLoader(false);
                this.addElements(result.body, () => {
                    this._loader = null;
                    this.loadNext();
                });
            });
        }
    }
    showLoader(value) {
        if (!this._loaderDiv) {
            this._loaderDiv = DomUtils.createElement('<div class="ChunkLoader-loader"></div>');
        }
        if (value) {
            this.html.appendChild(this._loaderDiv);
        }
        this._loaderDiv.hidden = !value;
    }
    addElements(html, callback) {
        const elements = DomUtils.createElements(html);
        const totalDelay = elements.length * 100;
        DomUtils.forEach(elements, (element) => {
            setTimeout(() => {
                this.html.appendChild(element);
            }, 100);
        });
        setTimeout(() => {
            vp.components.pushQueue('MediaItemComponent', MediaItemComponent);
            vp.components.pushQueue('ListSlider', ListSlider);
            vp.components.pushQueue('GridList', GridList);
            callback();
        }, totalDelay + 100);
    }
}
